export default __webpack_public_path__ + "static/media/intellectual.31d6cfe0.svg";